import React from 'react';
import ReactDOM from 'react-dom';

import {nodeObj} from './dataObj.js';
import {refHandler, inputOnChangeHandler, optionsSwitchFn} from './applicationFn.js';
import {optionRenderFn} from './optionRenderFn.js';

export function mainRenderFn (selectThis) {
  let content = [];
  let props_select = new nodeObj(selectThis.env, 'btb-select').props;
  if (selectThis.props.className) {props_select.className += ` ${selectThis.props.className}`;}
  
  let props_input = new nodeObj(selectThis.env, 'select-input').props;
  let props_text = new nodeObj(selectThis.env, 'input-text').props;
  let props_addition = new nodeObj(selectThis.env, 'input-addition').props;

  content.push(
    <div {...props_select} ref={(ref) => {_refHandler(ref);}}>
      <div {...props_input}>
        <input
          {...props_text}
          type='text'
          onChange={() => {_inputOnChangeHandler('set');}} 
          onFocus={() => {optionsSwitchFn(selectThis, true);}}
          ref='searchInput'
          id={selectThis.env.selectorId}
          placeholder={selectThis.env.placeholder}
        />
        {
          ('' === selectThis.printoutData.inputValue)?
            (
              ((selectThis.optionsActive)
                && (selectThis.env.featureSearch.enable)
              )?
                (
                  <span 
                    {...props_addition} 
                    onClick={() => {optionsSwitchFn(selectThis, true);}}
                    id={`${selectThis.env.selectorId}_button`}
                  >{selectThis.env.addtionalButton.searchButton}</span>
                ) :
                (
                  <span 
                    {...props_addition} 
                    onClick={() => {optionsSwitchFn(selectThis, true);}}
                    id={`${selectThis.env.selectorId}_button`}
                  >{selectThis.env.addtionalButton.selectButton}</span>
                )
            ) : (
              <span 
                {...props_addition} 
                onClick={() => {_inputOnChangeHandler('clear');}}
                id={`${selectThis.env.selectorId}_button`}
              >{selectThis.env.addtionalButton.clearButton}</span>
            )
        }
      </div>
      {
        (selectThis.optionsActive)?
          (
            optionRenderFn(selectThis)
          ): []
      }
    </div>
  );
  return content;

  function _refHandler (ref) {
    refHandler(selectThis, ref);
  }
  function _inputOnChangeHandler (actionType) {
    if (selectThis.env.featureSearch.enable)
    {
      inputOnChangeHandler(selectThis, actionType);
    }
    else
    {
      selectThis.printoutData.selectedOption = {};
      selectThis.printoutData.inputValue = '';
      ReactDOM.findDOMNode(selectThis.refs.searchInput).value = '';
      selectThis.forceUpdate();
    } 
  }
}
